<template>
    <v-expansion-panels flat>
        <v-expansion-panel class="rounded-lg">

            <!--Icon | Title | Text -->
            <v-expansion-panel-header class="d-flex flex-column align-start px-4">

                <!--Icon | Title -->
                <div class="d-flex align-center">

                    <!--Icon-->
                    <v-icon class="icons8-user-clock ma-n1" color="accent" size="48"/>

                    <!--Title-->
                    <app-text category="text-medium-bold" class="primary--text ml-4">User Approval</app-text>

                </div>

                <!--Message-->
                <app-text class="mt-4">{{ usersAwaitingApprovalMessage }}</app-text>

            </v-expansion-panel-header>

            <!--Awaiting approval-->
            <v-expansion-panel-content class="expansion-panel-content-container">

                <!--Users-->
                <div v-for="user in usersAwaitingApproval" class="mb-4">

                    <v-divider class="mb-4"/>

                    <app-text category="text-default-bold">{{ user.userName }}</app-text>
                    <app-text>{{ user.userPosition }}</app-text>
                    <app-text>{{ user.userEmail }}</app-text>
                    <app-text>{{ user.userTelephone }}</app-text>

                </div>

                <!--Action button-->
                <app-btn @click.native="MIX_go('staff-directory')"
                        block
                        label="Show Accounts"/>

            </v-expansion-panel-content>

        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {

    name: "awaitingApprovalHomePageCard",

    props: ['usersAwaitingApprovalMessage', 'usersAwaitingApproval'],

}
</script>
